<template>
    <div class="has-text-white top40 scrollableY">
        <div class="is-size-3 settsPad">Privacy Policy</div>


        <div class="settsPad">
          
          
           <div v-if="!cali">
                <p></p>
                <div class="is-size-4">California residents click <b @click="doCali(1)" class="handCursor">here</b></div>
                <br>
    <p>MIIMU LLC, a Florida limited liability company (&ldquo;<strong>Company</strong>&rdquo;<strong>, </strong>&ldquo;<strong>We</strong>&rdquo;<strong>, </strong>&ldquo;<strong>Us</strong>&rdquo;), respects your privacy and is committed to protecting it through our compliance with this policy.</p>
    
    
    <br>
    <p>This policy describes:</p>
    <ul>
    <li>The types of information we may collect or that you may provide when you purchase, download, install, register with, access, or use miimi.com or our mobile application or widgets, including any content, functionality, and services offered on or through such platforms (together, the &ldquo;<strong>Platforms</strong>&rdquo;).</li>
    </ul>
    <ul>
    <li>Our practices for collecting, using, maintaining, protecting, and disclosing that information.</li>
    </ul>
    <p>This policy applies only to information we collect in the Platforms, and in email, text, and other electronic communications sent through or in connection with the Platforms.&nbsp;</p>
    <p>This policy DOES NOT apply to information that:</p>
    <ul>
    <li>We collect offline or on any other Company apps or websites, including websites you may access through the Platforms.</li>
    <li>You provide to or is collected by any third party (see Third Party Information Collection).</li>
    </ul>
    <p>Our websites and apps, and these other third parties may have their own privacy policies, which we encourage you to read before providing information on or through them.</p>
    <p>Please read this policy carefully to understand our policies and practices regarding your information and how we will treat it. If you do not agree with our policies and practices, do not download, register with, or use the Platforms. By downloading, registering with, or using the Platforms, you agree to this privacy policy. This policy may change from time to time (see <a href="https://docs.google.com/document/d/1lOCkqr1Yf-6Ls0MgfqaLf1wqgtPJ3O75T14q9-zJkEE/edit#heading=h.2et92p0">Changes to Our Privacy Policy</a>). Your continued use of the Platforms after we revise this policy means you accept those changes, so please check the policy periodically for updates.&nbsp;</p>
    <p>&zwnj;</p>
    <h1><strong>Children Under the Age of 16</strong></h1>
    <p>The Platforms are not intended for children under 16 years of age, and we do not knowingly collect personal information from children under 16. If we learn we have collected or received personal information from a child under 16 without verification of parental consent, we will delete that information. If you believe we might have any information from or about a child under 16, please contact us at info@ miimu.com.</p>
    
    <table>
    <tbody>
    <tr>
    <td><br />
    <h1><strong>Information We Collect About You and How We Collect It</strong></h1>
    </td>
    </tr>
    </tbody>
    </table>
    <p>We collect information from and about users of our Platforms:</p>
    <ul>
    <li>Directly from you when you provide it to us.</li>
    <li>Automatically when you use the Platforms.</li>
    </ul>
    
    <table>
    <tbody>
    <tr>
    <td>
    <h1><strong>Information You Provide to Us</strong></h1>
    </td>
    </tr>
    </tbody>
    </table>
    <p>When you download, register with, or use the Platforms, we may ask you provide information:</p>
    <ul>
    <li>By which you may be personally identified, such as name, postal address, email address, telephone number, or information concerning stores or websites you may have visited or purchases you have made, or any other identifier by which you may be contacted online or offline (&ldquo;<strong>personal information</strong>&rdquo;).</li>
    </ul>
    <ul>
    <li>That is about you but individually does not identify you.</li>
    </ul>
    <p>This information includes:&nbsp;</p>
    <ul>
    <li>Information that you provide by filling in forms in the Platforms. This includes information provided at the time of registering to use the Platforms, subscribing to our service, posting material, and requesting further services. We may also ask you for information when you report a problem with the Platforms.</li>
    </ul>
    <ul>
    <li>Records and copies of your correspondence (including email addresses and phone numbers), if you contact us.</li>
    </ul>
    <ul>
    <li>Your responses to surveys that we might ask you to complete for research purposes.</li>
    </ul>
    <ul>
    <li>Details of transactions you carry out through the Platforms and of the fulfillment of your orders. You may be required to provide financial information before placing an order through the Platforms.</li>
    </ul>
    <ul>
    <li>Your search queries on the Platforms.</li>
    </ul>
    <p>You may also provide information for publication or display (&ldquo;<strong>Posted</strong>&rdquo;) on areas of the app or websites you access through the Platforms (collectively, &ldquo;<strong>User Contributions</strong>&rdquo;). Your User Contributions are Posted and transmitted to others at your own risk. Although you may set certain privacy settings for such information, please be aware that no security measures are perfect or impenetrable. Additionally, we cannot control the actions of third parties with whom you may choose to share your User Contributions. Therefore, we cannot and do not guarantee that your User Contributions will not be viewed by unauthorized persons.</p>
    
    <h1><strong>Automatic Information Collection and Tracking</strong></h1>
    <p>When you download, access, and use the Platforms, it may use technology to automatically collect:</p>
    <ul>
    <li><strong><strong>Usage Details.</strong> When you access and use the Platforms, we may automatically collect certain details of your access to and use of the Platforms, including traffic data, location data, logs, and other communication data and the resources that you access and use on or through the Platforms.&nbsp;</strong></li>
    </ul>
    <ul>
    <li><strong>Device Information.</strong> We may collect information about your mobile device and internet connection, including the device&rsquo;s unique device identifier, IP address, operating system, browser type, mobile network information, and the device&rsquo;s telephone number.</li>
    </ul>
    <ul>
    <li><strong>Stored Information and Files.</strong> The Platforms also may access metadata and other information associated with other files stored on your device. This may include, for example, photographs, audio and video clips, personal contacts, and address book information.</li>
    </ul>
    <ul>
    <li><strong>Location Information. </strong>Unless location-based features are disabled on your device in regard to the Platforms, the Platforms collect real-time information about the location of your device.</li>
    </ul>
    <p>If you do not want us to collect this information do not download the Platforms or delete them from your device. Alternatively, you may opt-out of some of this tracking. Note, however, that opting out of the Platforms&rsquo; collection of location information will disable its location-based features.</p>
    <p>We also may use these technologies to collect information about your activities over time and across third-party websites, apps, or other online services (behavioral tracking).&nbsp;</p>
    
    <h1><strong>Information Collection and Tracking Technologies</strong></h1>
    <p>The technologies we use for automatic information collection may include:</p>
    <ul>
    <li><strong><strong>Cookies (or mobile cookies).</strong> A cookie is a small file placed on your smartphone. It may be possible to refuse to accept mobile cookies by activating the appropriate setting on your smartphone. However, if you select this setting you may be unable to access certain parts of our Platforms.&nbsp;</strong></li>
    </ul>
    <ul>
    <li><strong>Web Beacons.</strong> Pages of the Platforms and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related app statistics (for example, recording the popularity of certain app content and verifying system and server integrity).</li>
    </ul>
    
    <h1><strong>Third-Party Information Collection</strong></h1>
    <p>When you use the Platforms or their content, certain third parties may use automatic information collection technologies to collect information about you or your device. These third parties may include:</p>
    <ul>
    <li>Advertisers, ad networks, and ad servers.</li>
    <li>Analytics companies.</li>
    <li>Your mobile device manufacturer.</li>
    <li>Your mobile service provider.</li>
    </ul>
    <p>These third parties may use tracking technologies to collect information about you when you use the Platforms. The information they collect may be associated with your personal information or they may collect information, including personal information, about your online activities over time and across different websites, apps, and other online services websites. They may use this information to provide you with interest-based (behavioral) advertising or other targeted content.&nbsp;</p>
    <p>We do not control these third parties&rsquo; tracking technologies or how they may be used. If you have any questions about an advertisement or other targeted content, you should contact the responsible provider directly.&nbsp;</p>
    
    <h1><strong>How We Use Your Information</strong></h1>
    <p>We use information that we collect about you or that you provide to us, including any personal information, to:</p>
    <ul>
    <li>Provide you with the Platforms and their contents, and any other information, products or services that you request from us.</li>
    <li>Fulfill any other purpose for which you provide it.</li>
    <li>Give you notices about your account, including expiration and renewal notices.</li>
    <li>Carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection.</li>
    <li>Notify you when updates to the Platforms are available, and of changes to any products or services we offer or provide though it.</li>
    </ul>
    <p>The usage information we collect helps us to improve the Platforms and to deliver a better and more personalized experience by enabling us to:</p>
    <ul>
    <li>Estimate our audience size and usage patterns.</li>
    <li>Store information about your preferences, allowing us to customize the Platforms according to your individual interests.</li>
    <li>Speed up your searches.</li>
    <li>Recognize you when you use the Platforms.</li>
    </ul>
    <p>We may also use your information to contact you about our own and third parties&rsquo; goods and services that may be of interest to you. If you do not want us to use your information in this way, please adjust your user preferences in your account profile. For more information, see <a href="https://docs.google.com/document/d/1lOCkqr1Yf-6Ls0MgfqaLf1wqgtPJ3O75T14q9-zJkEE/edit#heading=h.gjdgxs">Your Choices About Our Collection, Use, and Disclosure of Your Information</a>.</p>
    <p>We may use the information we collect to display advertisements to our advertisers&rsquo; target audiences. Even though we do not disclose your personal information for these purposes without your consent, if you click on or otherwise interact with an advertisement, the advertiser may assume that you meet its target criteria.</p>
    
    <h1><strong>Disclosure of Your Information</strong></h1>
    <p>We may disclose aggregated information about our users, and information that does not identify any individual or device, without restriction.&nbsp;</p>
    <p>In addition, we may disclose personal information that we collect or you provide:</p>
    <ul>
    <li>To our subsidiaries and affiliates.</li>
    <li>To contractors, service providers, and other third parties we use to support our business.</li>
    <li>To a buyer or other successor in the event of a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Company&rsquo;s assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal information held by Company about the Platforms&rsquo; users is among the assets transferred.</li>
    <li>To third parties to market their products or services to you if you have not opted out of these disclosures.</li>
    <li>To fulfill the purpose for which you provide it. For example, if you give us an email address to use the &ldquo;email a friend&rdquo; feature of our Platforms, we will transmit the contents of that email and your email address to the recipients.</li>
    <li>For any other purpose disclosed by us when you provide the information.</li>
    <li>With your consent.</li>
    <li>To comply with any court order, law, or legal process, including to respond to any government or regulatory request.</li>
    <li>To enforce our rights arising from any contracts entered into between you and us, including the Platforms&rsquo; end user license agreement, our Terms of Use, and for billing and collection.</li>
    <li>If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of Company, our customers or others. This includes exchanging information with other companies and organizations for the purposes of fraud protection and credit risk reduction.</li>
    </ul>
    <p></p>
    
    <h1><strong>Your Choices About Our Collection, Use, and Disclosure of Your Information</strong></h1>
    <p>We strive to provide you with choices regarding the personal information you provide to us. This section describes mechanisms we provide for you to control certain uses and disclosures of over your information.</p>
    <ul>
    <li><strong><strong>Tracking Technologies.</strong> You can set your browser to refuse all or some browser cookies, or to alert you when cookies are being sent. If you disable or refuse cookies or block the use of other tracking technologies, some parts of the Platforms may then be inaccessible or not function properly.</strong></li>
    </ul>
    <ul>
    <li><strong>Location Information.</strong> You can choose whether or not to allow the Platforms to collect and use real-time information about your device&rsquo;s location through the device&rsquo;s privacy settings. If you block the use of location information, some parts of the Platforms may become inaccessible or not function properly.</li>
    </ul>
    <ul>
    <li><strong>Promotion by the Company.</strong> If you do not want us to use your Contact Information (including your email address) to promote our own or third parties&rsquo; products or services, you can opt-out through your User Preferences. You can also always opt-out by logging into the Platforms and adjusting your user preferences in your account profile by checking or unchecking the relevant boxes.</li>
    </ul>
    <ul>
    <li><strong>Targeted Advertising by the Company.</strong> If you do not want us to use information that we collect or that you provide to us to deliver advertisements according to our advertisers&rsquo; target-audience preferences, you can opt-out through your User Preferences. You can also always adjust your user advertising preferences in your account profile by checking or unchecking the relevant boxes.</li>
    </ul>
    <ul>
    <li><strong>Disclosure of Your Information for Third-Party Advertising and Marketing.</strong> If you do not want us to share your personal information with unaffiliated or non-agent third parties for advertising and marketing purposes, you can opt-out by you can opt-out through your User Preferences. You can also always opt-out by logging into the Platforms and adjusting your user preferences in your account profile by checking or unchecking the relevant boxes.</li>
    </ul>
    <p>We do not control third parties&rsquo; collection or use of your information to serve interest-based advertising. However, these third parties may provide you with ways to choose not to have your information collected or used in this way.</p>
    <p>California residents may have additional personal information rights and choices. Please see <a href="https://docs.google.com/document/d/1lOCkqr1Yf-6Ls0MgfqaLf1wqgtPJ3O75T14q9-zJkEE/edit#heading=h.3znysh7">California Privacy Rights</a>.</p>
    <br>
    <h1><strong>Accessing and Correcting Your Personal Information</strong></h1>
    <p>You can review and change your personal information by logging into the Platforms and visiting your account profile page.</p>
    <p>California residents may have additional personal information rights and choices. Please see <a href="https://docs.google.com/document/d/1lOCkqr1Yf-6Ls0MgfqaLf1wqgtPJ3O75T14q9-zJkEE/edit#heading=h.3znysh7">California Privacy Rights</a>.</p>
    <br>
    <h1><strong>Data Security</strong></h1>
    <p>We have implemented measures designed to secure your personal information from accidental loss and from unauthorized access, use, alteration, and disclosure.&nbsp;</p>
    <p>The safety and security of your information also depends on you. Where we have given you (or where you have chosen) a password for access to certain parts of our Platforms, you are responsible for keeping this password confidential. We ask you not to share your password with anyone.&nbsp;</p>
    <p>Unfortunately, the transmission of information via the internet and mobile platforms is not completely secure. Although we do our best to protect your personal information, we cannot guarantee the security of your personal information transmitted through our Platforms. Any transmission of personal information is at your own risk. We are not responsible for circumvention of any privacy settings or security measures we provide.</p>
    <p><br /></p>
    
    <h1><strong>California Privacy Rights</strong></h1>
    <p>If you are a California resident, California law may provide you with additional rights regarding our use of your personal information. To learn more about your California privacy rights, please visit our California Privacy Policy. Please see <a href="https://docs.google.com/document/d/1lOCkqr1Yf-6Ls0MgfqaLf1wqgtPJ3O75T14q9-zJkEE/edit#heading=h.3znysh7">California Privacy Rights</a>.</p>
    <p>California&rsquo;s &ldquo;Shine the Light&rdquo; law (Civil Code Section &sect; 1798.83) permits users of our Platforms that are California residents to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make such a request, please send an email to info@miimu.com.</p>
    <p><br /></p>
    
    <h1><strong>Changes to Our Privacy Policy</strong></h1>
    <p>We may update our privacy policy from time to time. If we make material changes to how we treat our users&rsquo; personal information, we will post the new privacy policy on this page.</p>
    <p>The date the privacy policy was last revised is identified at the top of the page. You are responsible for ensuring we have an up-to-date active and deliverable email address for you and for periodically visiting this privacy policy to check for any changes.</p>
    <br>
    <h1><strong>Contact Information</strong></h1>
    <p>To ask questions or comment about this privacy policy and our privacy practices, contact us at: Info@miimu.com.</p>
    
    <br><br><br><br><br><br>
</div>



<div v-if="cali">
    <div class="is-size-4">Non-California residents click <b class="handCursor" @click="doCali(0)">here</b></div><br>
    

    
    <p>This <strong>California Privacy Policy for California Residents</strong> supplements the information contained in MIIMU LLC&rsquo;s (&ldquo;<strong>Company</strong>&rdquo;, &ldquo;<strong>We</strong>&rdquo;, &ldquo;<strong>Us</strong>&rdquo;<strong>) </strong>Privacy Policy<strong> www.miimu.com/privacy_policy</strong> (the &ldquo;<strong>Privacy Policy</strong>&rdquo;) and applies solely to all visitors, users, and others who reside in the State of California (&ldquo;<strong>Consumers</strong>&rdquo;, &ldquo;<strong>You</strong>&rdquo;). Capitalized terms used but not otherwise defined herein shall have the meanings assigned to such terms in the Privacy Policy. We adopt this notice to comply with the California Consumer Privacy Act of 2018 (&ldquo;<strong>CCPA</strong>&rdquo;) and any terms defined in the CCPA have the same meaning when used in this California Privacy Policy (this &ldquo;<strong>Policy</strong>&rdquo;).&nbsp;</p>
    <p>Where noted in this Policy, the CCPA temporarily exempts personal information reflecting a written or verbal business-to-business communication (&ldquo;<strong>B2B Personal Information</strong>&rdquo;) from some its requirements.</p>
    <br>
    <p><strong>Information We Collect</strong></p>
    <p>We collect information that identifies, relates to, describes, references, is reasonably capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular consumer, household, or device (&ldquo;<strong>Personal Information</strong>&rdquo;). Personal information does not include:</p>
    <ul>
    <li>Publicly available information from government records.</li>
    <li>Deidentified or aggregated consumer information.</li>
    <li>Information excluded from the CCPA&rsquo;s scope, like:</li>
    <ul>
    <li>health or medical information covered by the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and the California Confidentiality of Medical Information Act (CMIA), clinical trial data, or other qualifying research data;</li>
    <li>personal information covered by certain sector-specific privacy laws, including the Fair Credit Reporting Act (FCRA), the Gramm-Leach-Bliley Act (GLBA) or California Financial Information Privacy Act (FIPA), and the Driver&rsquo;s Privacy Protection Act of 1994.</li>
    </ul>
    </ul>
    <p>In particular, we have collected the following categories of personal information from consumers within the last twelve (12) months:&nbsp;</p><br>
    <table>
    <tbody>
    <tr>
    <td>
    <p><strong>Category</strong></p>
    </td>
    <td>
    <p><strong>Examples</strong></p>
    </td>
    <td>
    <p><strong>Collected</strong></p>
    </td>
    </tr>
    <tr>
    <td>
    <p>A. Identifiers.</p>
    </td>
    <td>
    <p>A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, account name, Social Security number, driver&rsquo;s license number, passport number, or other similar identifiers.</p>
    </td>
    <td>
    <p>YES</p>
    </td>
    </tr>
    <tr>
    <td>
    <p>B. Personal information categories listed in the California Customer Records statute (Cal. Civ. Code &sect; 1798.80(e)).</p>
    </td>
    <td>
    <p>A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport number, driver&rsquo;s license or state identification card number, insurance policy number, education, employment, employment history, bank account number, credit card number, debit card number, or any other financial information, medical information, or health insurance information.</p>
    <p>Some personal information included in this category may overlap with other categories.</p>
    </td>
    <td>
    <p>YES</p>
    </td>
    </tr>
    <tr>
    <td>
    <p>C. Protected classification characteristics under California or federal law.</p>
    </td>
    <td>
    <p>Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth and related medical conditions), sexual orientation, veteran or military status, or genetic information (including familial genetic information).</p>
    </td>
    <td>
    <p>YES</p>
    </td>
    </tr>
    <tr>
    <td>
    <p>D. Commercial information.</p>
    </td>
    <td>
    <p>Records of personal property, products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies.</p>
    </td>
    <td>
    <p>NO</p>
    </td>
    </tr>
    <tr>
    <td>
    <p>E. Biometric information.</p>
    </td>
    <td>
    <p>Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a template or other identifier or identifying information, such as, fingerprints, faceprints, and voiceprints, iris or retina scans, keystroke, gait, or other physical patterns, and sleep, health, or exercise data.</p>
    </td>
    <td>
    <p>NO</p>
    </td>
    </tr>
    <tr>
    <td>
    <p>F. Internet or other similar network activity.</p>
    </td>
    <td>
    <p>Browsing history, search history, information on a consumer&rsquo;s interaction with a website, application, or advertisement.</p>
    </td>
    <td>
    <p>YES</p>
    </td>
    </tr>
    <tr>
    <td>
    <p>G. Geolocation data.</p>
    </td>
    <td>
    <p>Physical location or movements.&nbsp;</p>
    </td>
    <td>
    <p>YES</p>
    </td>
    </tr>
    <tr>
    <td>
    <p>H. Sensory data.</p>
    </td>
    <td>
    <p>Audio, electronic, visual, thermal, olfactory, or similar information.</p>
    </td>
    <td>
    <p>YES</p>
    </td>
    </tr>
    <tr>
    <td>
    <p>I. Professional or employment-related information.</p>
    </td>
    <td>
    <p>Current or past job history or performance evaluations.</p>
    </td>
    <td>
    <p>NO</p>
    </td>
    </tr>
    <tr>
    <td>
    <p>J. Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99)).</p>
    </td>
    <td>
    <p>Education records directly related to a student maintained by an educational institution or party acting on its behalf, such as grades, transcripts, class lists, student schedules, student identification codes, student financial information, or student disciplinary records.&nbsp;</p>
    </td>
    <td>
    <p>NO</p>
    </td>
    </tr>
    <tr>
    <td>
    <p>K. Inferences drawn from other personal information.</p>
    </td>
    <td>
    <p>Profile reflecting a person&rsquo;s preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, and aptitudes.</p>
    </td>
    <td>
    <p>YES</p>
    </td>
    </tr>
    </tbody>
    </table>
    <br>
    <p><strong>Use of Personal Information</strong></p>
    <p>We may use, sell, or disclose the personal information we collect for one or more of the following purposes:&nbsp;</p>
    <ul>
    <li>To fulfill or meet the reason you provided the information. For example, if you share your name and contact information to request a price quote or ask a question about our products or services, we will use that personal information to respond to your inquiry. If you provide your personal information to purchase a product or service, we will use that information to process your payment and facilitate delivery. We may also save your information to facilitate new product orders or process returns.&nbsp;</li>
    <li>To provide, support, personalize, and develop our Platforms, products, and services.</li>
    <li>To create, maintain, customize, and secure your account with us.</li>
    <li>To process your requests, purchases, transactions, and payments and prevent transactional fraud.</li>
    <li>To provide you with support and to respond to your inquiries, including to investigate and address your concerns and monitor and improve our responses.</li>
    <li>To personalize your Platform experience and to deliver content and product and service offerings relevant to your interests, including targeted offers and ads through our Platforms, third-party sites, and via email or text message (with your consent, where required by law).</li>
    <li>To help maintain the safety, security, and integrity of our Platforms, products and services, databases and other technology assets, and business.</li>
    <li>For testing, research, analysis, and product development, including to develop and improve our Platforms, products, and services.</li>
    <li>To respond to law enforcement requests and as required by applicable law, court order, or governmental regulations.</li>
    <li>As described to you when collecting your personal information or as otherwise set forth in the CCPA.</li>
    <li>To evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal information held by us about our Platform users is among the assets transferred.</li>
    </ul>
    <p>We will not collect additional categories of personal information or use the personal information we collected for materially different, unrelated, or incompatible purposes without providing you notice.</p>
    <br>
    <p><strong>Sharing Personal Information</strong></p>
    <p>We may share your personal information by disclosing it to a third party for a business purpose. We only make these business purpose disclosures under written contracts that describe the purposes, require the recipient to keep the personal information confidential, and prohibit using the disclosed information for any purpose except performing the contract.&nbsp;</p>
    <p>[We do not sell personal information. We may also share your personal information by selling it to third parties, subject to your right to opt-out of those sales. Our personal information sales do not include information about individuals we know are under age 16. In the preceding twelve (12) months, Company has not sold any personal information.] </p>
    <br>
    <p><strong>Your Rights and Choices&nbsp;</strong></p>
    <p>The CCPA provides consumers (California residents) with specific rights regarding their personal information. This section describes your CCPA rights and explains how to exercise those rights.</p>
    <br>
    <p><strong><em>Right to Know and Data Portability</em></strong></p>
    <p>You have the right to request that we disclose certain information to you about our collection and use of your personal information over the past 12 months (the &ldquo;right to know&rdquo;). Once we receive your request and confirm your identity (<em>see</em> <a href="https://docs.google.com/document/d/1x-IJnsOIISQY-uLsTQSAWMj7GamK6iWmwtd7ETdGUfM/edit#bookmark=id.4d34og8">Exercising Your Rights to Know or Delete</a>), we will disclose to you:</p>
    <ul>
    <li>The categories of personal information we collected about you.</li>
    <li>The categories of sources for the personal information we collected about you.</li>
    <li>Our business or commercial purpose for collecting or selling that personal information.</li>
    <li>The categories of third parties with whom we share that personal information.</li>
    <li>If we sold or disclosed your personal information for a business purpose, two separate lists disclosing:</li>
    <ul>
    <li>sales, identifying the personal information categories that each category of recipient purchased; and&nbsp;</li>
    <li>disclosures for a business purpose, identifying the personal information categories that each category of recipient obtained.&nbsp;</li>
    </ul>
    <li>The specific pieces of personal information we collected about you (also called a data portability request).</li>
    </ul>
    <p>&nbsp;We do not provide a right to know or data portability disclosure for B2B Personal Information.</p>
    <br>
    <p><strong><em>Right to Delete&nbsp;</em></strong></p>
    <p>You have the right to request that we delete any of your personal information that we collected from you and retained, subject to certain exceptions (the &ldquo;right to delete&rdquo;). Once we receive your request and confirm your identity (<em>see</em> <a href="https://docs.google.com/document/d/1x-IJnsOIISQY-uLsTQSAWMj7GamK6iWmwtd7ETdGUfM/edit#bookmark=id.4d34og8">Exercising Your Rights to Know or Delete</a>), we will review your request to see if an exception allowing us to retain the information applies. We may deny your deletion request if retaining the information is necessary for us or our service provider(s) to:&nbsp;</p>
    <ol>
    <li>Complete the transaction for which we collected the personal information, provide a good or service that you requested, take actions reasonably anticipated within the context of our ongoing business relationship with you, fulfill the terms of a written warranty or product recall conducted in accordance with federal law, or otherwise perform our contract with you.</li>
    <li>Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute those responsible for such activities.</li>
    <li>Debug products to identify and repair errors that impair existing intended functionality.</li>
    <li>Exercise free speech, ensure the right of another consumer to exercise their free speech rights, or exercise another right provided for by law.</li>
    <li>Comply with the California Electronic Communications Privacy Act (Cal. Penal Code &sect; 1546 <em>et. seq.</em>).</li>
    <li>Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when the information&rsquo;s deletion may likely render impossible or seriously impair the research&rsquo;s achievement, if you previously provided informed consent.</li>
    <li>Enable solely internal uses that are reasonably aligned with consumer expectations based on your relationship with us.</li>
    <li>Comply with a legal obligation.</li>
    <li>Make other internal and lawful uses of that information that are compatible with the context in which you provided it.</li>
    </ol>
    <p>We will delete or deidentify personal information not subject to one of these exceptions from our records and will direct our service providers to take similar action.&nbsp;</p>
    <p>We do not provide these deletion rights for B2B Personal Information.</p>
    <br>
    <p><strong><em>Exercising Your Rights to Know or Delete</em></strong></p>
    <p>To exercise your rights to know or delete described above, please submit a request by either:&nbsp;</p>
    <ul>
    <li>Emailing us at [info@miimu.com]</li>
    <li>Visiting www.miimu.com</li>
    </ul>
    <p>Only you, or someone legally authorized to act on your behalf, may make a request to know or delete related to your personal information.&nbsp;</p>
    <p>You may only submit a request to know twice within 12-month period. Your request to know or delete must:</p>
    <ul>
    <li>Provide sufficient information that allows us to reasonably verify you are the person about whom we collected personal information or an authorized representative.</li>
    <li>Describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to it.</li>
    </ul>
    <p>We cannot respond to your request or provide you with personal information if we cannot verify your identity or authority to make the request and confirm the personal information relates to you.&nbsp;</p>
    <p>You do not need to create an account with us to submit a request to know or delete.&nbsp;</p>
    <p>We will only use personal information provided in the request to verify the requestor&rsquo;s identity or authority to make it.&nbsp;</p>
    <p>For instructions on exercising your sale opt-out or opt-in rights, see <a href="https://docs.google.com/document/d/1x-IJnsOIISQY-uLsTQSAWMj7GamK6iWmwtd7ETdGUfM/edit#bookmark=id.35nkun2">Personal Information Sales Opt-Out and Opt-In Rights</a>.</p>
    <br>
    <p><strong><em>Response Timing and Format</em></strong></p>
    <p>We will confirm receipt of your request within ten (10) business days. If you do not receive confirmation within the 10-day timeframe, please contact info@miimu.com.</p>
    <p>We endeavor to substantively respond to a verifiable consumer request within forty-five (45) days of its receipt. If we require more time (up to another 45 days), we will inform you of the reason and extension period in writing.</p>
    <p>If you have an account with us, we will deliver our written response to that account. If you do not have an account with us, we will deliver our written response by mail or electronically, at your option.&nbsp;</p>
    <p>Any disclosures we provide will only cover the 12-month period preceding our receipt of your request. The response we provide will also explain the reasons we cannot comply with a request, if applicable. For data portability requests, we will select a format to provide your personal information that is readily useable and should allow you to transmit the information from one entity to another entity without hindrance.</p>
    <p>We do not charge a fee to process or respond to your verifiable consumer request unless it is excessive, repetitive, or manifestly unfounded. If we determine that the request warrants a fee, we will tell you why we made that decision and provide you with a cost estimate before completing your request.&nbsp;</p>
    <br>
    <p><strong>Non-Discrimination</strong></p>
    <p>We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, we will not:</p>
    <ul>
    <li>Deny you goods or services.</li>
    <li>Charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties.</li>
    <li>Provide you a different level or quality of goods or services.</li>
    <li>Suggest that you may receive a different price or rate for goods or services or a different level or quality of goods or services.</li>
    </ul>
    <p>However, we may offer you certain financial incentives permitted by the CCPA that <strong>can result </strong>in different prices, rates, or quality levels. Any CCPA-permitted financial incentive we offer will reasonably relate to your personal information&rsquo;s value and contain written terms that describe the program&rsquo;s material aspects. Participation in a financial incentive program requires your prior opt-in consent, which you may revoke at any time.&nbsp;</p>
    <br>
    <p><strong>Changes to Our Privacy Policy</strong></p>
    <p>We reserve the right to amend this privacy policy at our discretion and at any time. When we make changes to this privacy policy, we will post the updated notice on the Platforms and update the notice&rsquo;s effective date. <strong>Your continued use of our Platforms following the posting of changes constitutes your acceptance of such changes</strong>.</p>
    <br>
    <p><strong>Contact Information</strong></p>
    <p>If you have any questions or comments about this notice, the ways in which We collect and use your information described here and in the <strong>Privacy Policy</strong>, your choices and rights regarding such use, or wish to exercise your rights under California law, please do not hesitate to contact us at:</p>
    <p><strong>Website</strong>: <a href="https://www.miimu.com">www.miimu.com</a></p>
    <p><strong>Email</strong>: <a href="mailto:info@miimu.com"><strong>info@miimu.com</strong></a></p>
    <p>Attn: Customer Service</p>
    <p>If you need to access this Policy in an alternative format due to having a disability, please contact us at:&nbsp;</p>
    <p><strong>Email</strong>: <a href="mailto:info@miimu.com"><strong>info@miimu.com</strong></a></p>
    <p><br /><br /><br /><br /><br /></p>
</div>


        </div>
        <!-- <footerDiv></footerDiv> -->
    </div>
</template>

<script>

import footerDiv from './Footer.vue'
export default{
    components: {footerDiv},
    data: function(){
        return {
            cali: false
        }
    },
    methods: {
       doCali: function(val){
           if(val == 0){
            this.cali = false
           } else {
            this.cali = true
           }
       } 
    }
}


</script>


<style scoped>
    ul {
        margin-left: 20px;
        margin-bottom: 20px
    }

    li::before{
        content: '•'
    }

    a{
        color: #ccc;
        text-decoration: underline;
        
    }

    a:hover{
        color: white
    }
    
</style>